module.exports = __webpack_public_path__ + "img/classImpot.2e68de4c.png";